import { Component } from "@angular/core";

@Component({
    selector: "paginator-storybook",
    templateUrl: "./paginator-storybook.component.html",
})

export class PaginatorStoryBookComponent {
}
